<template>
    <div class="container">
        <h2>Código de verificación</h2>
        <p>Selecciona cómo quieres recibir el código:</p>
        <div class="form-row mt-1">
            <div class="form-group">
                <label class="custom-radio-label">
                    <div>

                        <input
                            type="radio"
                            name="method"
                            value="whatsapp"
                            class="custom-input-transparent"
                            @focus="trackFormFieldFocus('verify_user-whatsapp_checkBoxx')"
                        >
                    </div>
                    <span>WhatsApp</span>
                </label>
                
            </div>
            <!-- <div class="form-group">
                <label class="custom-radio-label">
                    <input
                        type="radio"
                        name="method"
                        value="whatsapp"
                        class="custom-input-transparent"
                        @focus="trackFormFieldFocus('verify_user-email_checkBoxx')"
                    >
                    <span>Correo</span>
                </label>
                
            </div> -->
        </div>
        <button @click="sendCode" class="btn btn-primary">Envíar</button>
        
        <div class="code-section mt-2" v-if="codeIsSend">
            <p>Ingresa el código que te envíamos:</p>
            <div class="form-group">
                <input
                    v-model="code"
                    name="code"
                    type="text"
                    :class="['custom-input-transparent', {'is-invalid': false}]"
                    placeholder="Verification Code"
                    @focus="trackFormFieldFocus('verify_user-code_input')"
                >
            </div>
            <button @click="verifyCode" id="verifyCode" class="btn btn-success">Verificar</button>
        </div>
    </div>
</template>
<script>
import { useGoogleAnalytics } from '../../composables/useGoogleAnalytics';
import apiClient from '../../services/apiClient';
import Swal from 'sweetalert2';

export default {
    name: 'verify-user',
    setup() {
        const {trackPageView, trackFormFieldFocus, trackFormSubmission} = useGoogleAnalytics()
        return { trackPageView, trackFormFieldFocus, trackFormSubmission }
    },
    data() {
        return {
            codeIsSend: false,
            code: ''
        }
    },
    methods: {
        sendCode() {
            this.trackFormSubmission('on_submit_send_user_code')
            fetch('/api/verify/sendCode')
            .then(response => response.json())
            .then(result => {
                console.log(result);
            });
            this.codeIsSend = true;
            Swal.fire({
                title: 'Se solicitó el envío de tu código',
                text: 'Si no llega por favor vuelve a intentar',
                showCancelButton: true,
                confirmButtonText: 'Reintentar',
                cancelButtonText: 'Cerrar',
                heightAuto: false,
                didOpen: () => {
                    const btn = Swal.getConfirmButton();
                    btn.disabled = true;
                    setTimeout(() => {
                        btn.disabled = false;
                    }, 60000);
                }
            }).then((result) => {
                if (result.isConfirmed) {
                    this.sendCode();
                }
            });
        },
        verifyCode() {
            this.trackFormSubmission('on_submit_verify_user_code')
            const formData = new FormData();
            formData.append('code', this.code);
            apiClient.post('/api/verify/verifyCode', formData)
            .then(result => {
                if(result.data.message !== 'Verified') return

                let redirect_to = sessionStorage.getItem('quotationRequest') ? '/order/create' : '/order/view'
                location.href = redirect_to;
            });
            this.codeIsSend = true;
        }
    },
    mounted() {
        this.trackPageView('VERIFY_USER_PAGE')
    }
}
</script>
